import entityManager from '../entity-manager';

export const JSON_API_RESOURCE_DECORATOR_KEY = 'JSON_API_RESOURCE_DECORATOR_KEY';

export default function JsonApiResource(jsonApiResourceOptions: { type: string }) {
  return function (constructor: any) {
    const metadata = Reflect.getMetadata(JSON_API_RESOURCE_DECORATOR_KEY, constructor) || {};
    metadata.type = jsonApiResourceOptions.type;
    Reflect.defineMetadata(JSON_API_RESOURCE_DECORATOR_KEY, metadata, constructor);
    entityManager.registerResource(jsonApiResourceOptions.type, constructor);
  };
}
